import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#031f30" }, [
      _createElementVNode("path", { d: "M5.569 8a.625.625 0 0 0-.625.625v5.25a.625.625 0 1 0 1.25 0v-5.25A.625.625 0 0 0 5.569 8M9.05 8a.625.625 0 0 0-.625.625v5.25a.625.625 0 1 0 1.25 0v-5.25A.625.625 0 0 0 9.05 8" }),
      _createElementVNode("path", { d: "M13.844 3.575h-3.05V2.062A1.31 1.31 0 0 0 9.488.75H5.113a1.31 1.31 0 0 0-1.307 1.313v1.512H.75a.625.625 0 0 0 0 1.25h.881v12.106a1.306 1.306 0 0 0 1.306 1.313h8.707a1.3 1.3 0 0 0 .925-.381c.245-.248.382-.583.381-.932V4.825h.869a.625.625 0 0 0 0-1.25zM5.138 2.062h4.375v1.513H5.138zm6.53 14.87H2.964V4.905h8.706z" })
    ], -1)
  ]))]))
}
export default { render: render }